import { HostListener, Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import * as Highcharts from 'highcharts';
import { ApiMethod } from '../../apimethods/api-method';
import { HomeModel } from './home-model';
import { ArticleinfoComponent } from '../../articleinfo/articleinfo.component';
import { ArticleComponent } from '../../article/article.component';

declare var $;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [ArticleComponent],
})
/** home component*/
export class HomeComponent {

  modelData: HomeModel = new HomeModel();
  http: HttpClient; ArticleListTitle: string;


  constructor(private router: Router, http: HttpClient, private articleCom: ArticleComponent, private fb: FormBuilder) {
    GlobalConstants.siteTitle = 'Dashboard';
    this.http = http;
    this.GetProjectManagerList();
    this.LoadChartData(null, null, null);
    this.modelData.ArticleSummary = null;
    this.getPubCountryState();
  }

  allocate() {
    this.articleCom.allocate();
  }

  articleAllocate() {
    this.articleCom.articleAllocate();
  }

  summaryH5Title: string;
  dataTableJrlIssue: any;
  dtOptions: any;
  tableDataJrlIssue = [];
  @ViewChild('dataTableJrlIssue', { static: false }) tableJrlIssue;
  dataSetJrlIssue: any;


  dataTableArticle: any;
  tableDataArticle = [];
  @ViewChild('dataTableArticle', { static: false }) tableArticle;
  dataSetArticle: any;

  dataTableArticleAnnual: any;
  tableDataArticleAnnual = [];
  @ViewChild('dataTableArticleAnnual', { static: false }) tableArticleAnnual;
  dataSetArticleAnnual: any;

  dataTableIngestion: any;
  tableDataIngestion = [];
  @ViewChild('dataTableIngestion', { static: false }) tableIngestion;
  dataSetIngestion: any;

  tableDataBudgetArticle = [];
  @ViewChild('dataTableBudgetArticle', { static: false }) tableBudgetArticle;
  dataSetBudgetArticle: any;

  dataTableCustomerApiFailed: any;
  tableDataCustomerApiFailed = [];
  @ViewChild('dataTableCustomerApiFailed', { static: false }) tableCustomerApiFailed;
  dataSetCustomerApiFailed: any;

  Artpopuptitle: string;
  showpopupModal: boolean;


  @HostListener('window:beforeunload') goToPage() {
    this.router.navigate(['/home']);
  }
  public checkMetadataShow: boolean = GlobalConstants.CheckMetadataView('MetaData');

  public HideSummaryPanel: boolean = GlobalConstants.CheckMetadataView('Hide Summary Panel');

  public HideGraphView: boolean = GlobalConstants.CheckMetadataView('Hide Summary Graph');

  ngOnInit() {
    this.form = this.fb.group({
      contributors: this.fb.array([])
    });

    $("#lstJournals").select2({
      placeholder: "Select Journal", dropdownParent: "#divMainFilter"
    }); $("#lstJournals").val([]).trigger("change");

    $("#lstVolume").select2({
      placeholder: "Select Volume", dropdownParent: "#divMainFilter"
    });
    $("#lstVolume").val([]).trigger("change");

    $("#lstIssue").select2({
      placeholder: "Select Issue", dropdownParent: "#divMainFilter"
    });
    $("#lstIssue").val([]).trigger("change");

    $("#ddl_ProjectManager").select2({
      placeholder: "Select Project Manager",
      allowClear: true, dropdownParent: "#tblArticleAnnual"
    });
    $("#ddl_ProjectManager").val([]).trigger("change");

    $('#divArticleSummary').css('height', (GlobalConstants.size.height) - 150);

    $('#tblJrlIssueList,#tblArtList,#divSummaryitem').css('height', (GlobalConstants.size.height) - 150);

    customfunctions.SetDateValues('#Txt_FromDate', '#Txt_ToDate');

    this.ArticleListTitle = 'WIP Articles';
    this.FetchListDataTab();

    //Hide summary panel and show grid list full width
    if (this.HideSummaryPanel) {
      $('#divArticleDetails,#divIssueDetails').attr('class', 'col-sm-12');
    }
     
  }

  autoRefreshData() {
    this.GetSummartItem(this.summaryH5Title, true);
    this.GetJournalArticleStage(this.summaryH5Title, true);
  }

  GetProjectManagerList(): void {
    $("#LoadingImage").show();
    ApiMethod.getMethod('dash/GetProjectManagerList/' + localStorage.aPubID).subscribe(
      resonse => {
        this.modelData.ProjectManagerList = resonse.aitemList;
        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
      }
    );

  }

  //Load Initial Data
  FetchListDataTab() {
    this.GetSummartItem();
    //this.GetJournalArticleStage();
    //this.GetJournalIssue();

  }
  GetViewList(item): void {
    $('.spicon').removeClass('diactive');
    $('#spd' + item).addClass('diactive');
    if (item == 'List') {
      $('#divDashListbased').show(); $('#divDashGraphBased').hide();
      this.FetchListDataTab();
    }
    else {
      $('#divDashListbased').hide(); $('#divDashGraphBased').show();
      const popupDiv = document.getElementById("tblArticleAnnual");
      if (popupDiv.style.display === "none") {
        $('#maingraph').show(); $('#artgraph').hide();
        this.GetDashboardDetails();
      }
      else {
        $('#maingraph').hide(); $('#artgraph').show();
        this.GetDashboardartDetails();
      }
    }
  }

  GetWidgetItem(): void {
    $("#LoadingImageDashWidget").show();
    var postData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      FromDate: $('#Txt_FromDate').val(),
      ToDate: $('#Txt_ToDate').val()
    };
    ApiMethod.postMethod('dash/widget', postData).subscribe(
      resonse => {

        this.modelData.WidgetItem = JSON.parse(JSON.stringify(resonse.widgetList));

        $("#LoadingImageDashWidget").hide();
      },
      error => {
        $("#LoadingImageDashWidget").hide();
      }
    );

  }


  GetDashboardDetails(): void {
    $("#LoadingImage").show();
    var postData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      FromDate: $('#Txt_FromDate').val(),
      ToDate: $('#Txt_ToDate').val()
    };
    ApiMethod.postMethod('dash/summary', postData).subscribe(
      resonse => {
        let asummaryList = resonse.aitemList;
        //let aitem = JSON.stringify(asummaryList);
        let chartData: any = []; let chartDataCol: any = [];

        this.modelData.ArticleSummary = JSON.parse(JSON.stringify(resonse.articleSummary));

        let monthList: any = [];
        $(asummaryList).each(function (index, val) {
          chartDataCol.push({ y: val.CompletedArticles, name: val.CurrentMonth });
          monthList.push(val.CurrentMonth);
        });

        let articleSummary = resonse.articleSummary;
        $(articleSummary).each(function (index, val) {
          chartData.push({ y: val.ArtCount, name: val.SummaryName });
        });
        this.LoadChartData(chartData, chartDataCol, monthList);
        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
      }
    );

  }

  highchartsPie: typeof Highcharts = Highcharts; chartOptions;
  highchartsCol: typeof Highcharts = Highcharts; chartOptionsCol;

  LoadChartData(chartData, chartDataCol, monthList): void {
    try {
      let colorArray = ['#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
        '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'];

      this.highchartsPie = Highcharts;
      this.chartOptions = {
        chart: {
          style: {
            fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
          },
          plotBorderWidth: null,
          plotShadow: false,
        },
        title: {
          text: 'Stage Summary'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y}',
            },
            color: colorArray
          }
        },
        series: [{
          type: 'pie',
          name: "count",
          data: chartData
        }]
      };


      //Column Chart
      this.highchartsCol = Highcharts;
      this.chartOptionsCol = {
        chart: {
          type: 'column',
          style: {
            fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
          }
        },
        title: {
          text: 'Completed Articles'
        },
        xAxis: {
          categories: monthList,
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },
        tooltip: {
          headerFormat: '<span style = "font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
            '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
        },
        series: [{
          name: 'Count',
          data: chartDataCol,
          dataLabels: {
            enabled: true,
            color: '#000',
            format: '{point.y}'
          }
        }],

      };


    } catch (e) {
      $("#LoadingImage").hide();
      ngswal(e);
    }
  }

  GetDashboardartDetails(): void {
    $("#LoadingImage").show();
    var postData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      FromDate: $('#Txt_FromDate').val(),
      ToDate: $('#Txt_ToDate').val()
    };
    ApiMethod.postMethod('dash/ArticleSummary', postData).subscribe(
      resonse => {

        let aPubartList = resonse.adashboardPubartList;

        const categories = aPubartList.map(item => item.SummaryContent);

        const seriesData = [{
          name: 'Wip Articles',
          data: aPubartList.map(item => item.WipArticles)
        }, {
          name: 'Published Article',
          data: aPubartList.map(item => item.PublishedArticle)
        }, {
          name: 'Budget Article',
          data: aPubartList.map(item => item.BudgetArticle)
        }, {
          name: 'Avg.DaysTaken',
          data: aPubartList.map(item => item.PublishedAverageDaysTaken)
        }];
        this.LoadArtChartData(categories, seriesData);

        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
      }
    );

  }

  highchartsArtCol: typeof Highcharts = Highcharts; chartOptionsartCol;
  LoadArtChartData(categories, seriesData): void {
    try {
      this.highchartsArtCol = Highcharts;
      this.chartOptionsartCol = {
        chart: {
          type: 'column',
          style: {
            fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
          }
        },
        title: {
          text: 'Budget Summary'
        },
        xAxis: {
          categories: categories,
        },
        yAxis: {
          title: {
            text: 'Articles Count'
          }
        },
        series: seriesData
      };
    } catch (e) {
      $("#LoadingImage").hide();
      ngswal(e);
    }
  }

  jrnIssueList: [];
  //Journal based issue articles
  GetJournalIssue(): void {
    $("#LoadingImageDashJrlIssue").show();
    var postData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      FromDate: $('#Txt_FromDate').val(),
      ToDate: $('#Txt_ToDate').val()
    };
    ApiMethod.postMethod('dash/IssueArticles', postData).subscribe(
      resonse => {
        this.jrnIssueList = resonse.aitemList;

        this.dataSetJrlIssue = JSON.stringify(resonse.aitemList); // Data List
        this.dataSetJrlIssue = JSON.parse(this.dataSetJrlIssue);
        this.dataTableJrlIssue = $(this.tableJrlIssue.nativeElement);

        //Dynamic datable
        let aColList = resonse.aitemColList;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTableJrlIssue;
        dataItem.dataset = this.dataSetJrlIssue;
        dataItem.dtheight = (GlobalConstants.size.height - 200);
        dataItem.modulename = 'JournalwiseIssueHome';
        dataItem.defaultPagesize = -1;
        //dataItem.searchButton = false;
        dataItem.infoPopupID = "IssueID";
        dataItem.LengthChange = false;
        this.dataTableJrlIssue = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImageDashJrlIssue").hide();
      },
      error => {
        $("#LoadingImageDashJrlIssue").hide();
      }
    );

  }

  jrnArticleStageList: [];
  articleCount = 0;

  //Journal based issue articles
  GetJournalArticleStage(filterType = 'All', skipLoading = false): void {
    if (!skipLoading) { $("#LoadingImageDashArt").show(); }
    let currentYear = new Date().getFullYear();
    if (filterType == "Ingestion") {
      this.GetIngestion();
    } else {
      var postData = {
        LoginID: localStorage.aLoginID,
        PublisherID: localStorage.aPubID,
        FromDate: $('#Txt_FromDate').val(),
        ToDate: $('#Txt_ToDate').val(),
        FilterType: filterType,
        AnnualYear: currentYear,
        ProjectManager: $('#ddl_ProjectManager').val().toString()
      };

      ApiMethod.postMethod('dash/ArticlesStage', postData).subscribe(
        resonse => {
          this.jrnArticleStageList = resonse.aitemList;
          this.articleCount = resonse.aitemList.length;

          if (filterType == 'JournalBudget') {

            this.dataSetArticleAnnual = JSON.stringify(resonse.aitemList); // Data List
            this.dataSetArticleAnnual = JSON.parse(this.dataSetArticleAnnual);
            this.dataTableArticleAnnual = $(this.tableArticleAnnual.nativeElement);

            let tableHeight = 320;
            if (this.HideGraphView) {

            }
            //Dynamic datable
            let aColList = resonse.aitemColList;
            let dataItem = new DataParam();
            dataItem.acolList = aColList;
            dataItem.dataTable = this.dataTableArticleAnnual;
            dataItem.dataset = this.dataSetArticleAnnual;
            dataItem.dtheight = (GlobalConstants.size.height - 320);
            dataItem.modulename = 'JournalBudgetHome';
            //dataItem.searchButton = false;
            dataItem.defaultPagesize = -1;
            dataItem.infoPopupID = "Id";
            dataItem.LengthChange = false;
            dataItem.ExportFileName = filterType;
            this.dataTableArticleAnnual = customfunctions.dynamicDataTable(dataItem);
            //Dynamic datable
          }
          else if (filterType == 'CustomerApiFailed') {

            this.dataSetCustomerApiFailed = JSON.stringify(resonse.aitemList); // Data List
            this.dataSetCustomerApiFailed = JSON.parse(this.dataSetCustomerApiFailed);
            this.dataTableCustomerApiFailed = $(this.tableCustomerApiFailed.nativeElement);

            let tableHeight = 200;
            if (this.HideGraphView) {
              tableHeight = 180;
            }

            //Dynamic datable
            let aColList = resonse.aitemColList;
            let dataItem = new DataParam();
            dataItem.acolList = aColList;
            dataItem.dataTable = this.dataTableCustomerApiFailed;
            dataItem.dataset = this.dataSetCustomerApiFailed;
            dataItem.dtheight = (GlobalConstants.size.height - tableHeight);
            dataItem.modulename = 'CustomerApiFailed';
            //dataItem.searchButton = false;
            dataItem.defaultPagesize = -1;
            dataItem.infoPopupID = "ID";
            dataItem.LengthChange = false;
            dataItem.ExportFileName = filterType;
            this.dataTableCustomerApiFailed = customfunctions.dynamicDataTable(dataItem);
            //Dynamic datable
          }
          else {

            let tableHeight = 200;
            if (this.HideGraphView) {
              tableHeight = 180;
            }

            this.dataSetArticle = JSON.stringify(resonse.aitemList); // Data List
            this.dataSetArticle = JSON.parse(this.dataSetArticle);
            this.dataTableArticle = $(this.tableArticle.nativeElement);

            //Dynamic datable
            let aColList = resonse.aitemColList;
            let dataItem = new DataParam();
            dataItem.acolList = aColList;
            dataItem.dataTable = this.dataTableArticle;
            dataItem.dataset = this.dataSetArticle;
            dataItem.dtheight = (GlobalConstants.size.height - tableHeight);
            dataItem.modulename = 'ArticleDetailsStatusHome';
            dataItem.defaultPagesize = -1;
            //dataItem.searchButton = false;
            dataItem.infoPopupID = "ID";
            dataItem.LengthChange = false;
            dataItem.ExportFileName = filterType;
            this.dataTableArticle = customfunctions.dynamicDataTable(dataItem);
            //Dynamic datable
          }

          $("#LoadingImageDashArt").hide();
        },
        error => {
          $("#LoadingImageDashArt").hide();
        }
      );
    }
  }

  //Load Ingestion & Ucc failed
  GetIngestion(): void {
    $("#LoadingImageDashArt").show();
    var fromDate = $("#Txt_FromDate").val();//'01/01/2021';
    var toDate = $("#Txt_ToDate").val();
    var postData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      FromDate: fromDate.toString(),
      ToDate: toDate.toString(),
      SelectedStatus: "Failed",
      Journals: $("#lstJournals").val().toString(),
      Volume: $("#lstVolume option:selected").text(),
      Issue: $("#lstIssue option:selected").text()

    };
    ApiMethod.postMethod('api/GetIngestionList', postData).subscribe(
      resonse => {

        this.dataSetIngestion = JSON.stringify(resonse.aitemList); // Data List
        this.dataSetIngestion = JSON.parse(this.dataSetIngestion);
        this.dataTableIngestion = $(this.tableIngestion.nativeElement);

        //Dynamic datable
        let aColList = resonse.acolListL;
        aColList = aColList.filter(function (elem) {
          return (elem.ColumnData !== 'ArticleTitle' && elem.ColumnData !== 'VolIssue' && elem.ColumnTitle !== 'Action');
        });
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTableIngestion;
        dataItem.dataset = this.dataSetIngestion;
        dataItem.dtheight = (GlobalConstants.size.height - 200);
        dataItem.modulename = 'IngestionModule';
        dataItem.defaultPagesize = -1;
        //dataItem.searchButton = false;
        dataItem.infoPopupID = "IngestID";
        dataItem.LengthChange = false;
        this.dataTableIngestion = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable
        $("#LoadingImageDashArt").hide();
      },
      error => {
        $("#LoadingImageDashArt").hide();
      }
    );

  }


  showIngestionLog(ingetId) {
    var ingestionData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      InstId: ingetId
    };

    ApiMethod.postMethod('api/GetIngestionDetails', ingestionData).subscribe(
      result => {
        this.modelData.showModal = true;
        this.modelData.title = "Log Details";
        this.modelData.ingestTitle = result.PackageName;

        this.modelData.ingestStatus = result.StatusName;
        this.modelData.ingestStartDate = GlobalConstants.FormatDate(result.ReceivedDate);
        this.modelData.ingestCompleteDate = GlobalConstants.FormatDate(result.CompletedDate);
        this.modelData.ingestDescription = result.IngestInfo;

        this.modelData.uccStatus = result.UCCStatusName;
        this.modelData.uccStartDate = GlobalConstants.FormatDate(result.UCCReceivedDate);
        this.modelData.uccCompleteDate = GlobalConstants.FormatDate(result.UCCCompletedDate);
        this.modelData.uccDescription = result.UCCInfo;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  hideIngestionLog() {
    this.modelData.showModal = false;
  }

  LoadGridByType(filter): void {
    $('h6.h5active').removeClass('h5active');

    let summarTr = $('#span' + filter);
    $(summarTr).addClass('h5active');

    this.summaryH5Title = filter;
    this.ArticleListTitle = $(summarTr).attr('data-summaryname');

    if (filter == "IssueDetails") {
      $('#divIssueDetails').show();
      $('#divArticleDetails').hide();
      $('#tblCustomerApiFailed').hide();
      this.GetJournalIssue();
    }
    else {
      $('#divArticleDetails').show();
      $('#divIssueDetails').hide();
      $('#tblCustomerApiFailed').hide();

      if (filter == "Ingestion") {
        $('#tblIngestionList').show();
        $('#tblArticleList').hide();
        $('#tblArticleAnnual').hide();
        $('#tblCustomerApiFailed').hide();
      }
      else if (filter == "CustomerApiFailed") {
        $('#tblCustomerApiFailed').show();
        $('#tblIngestionList').hide();
        $('#tblArticleList').hide();
        $('#tblArticleAnnual').hide();
      }
      else if (filter == 'JournalBudget') {
        $('#tblIngestionList').hide();
        $('#tblArticleList').hide();
        $('#tblArticleAnnual').show();
        $('#tblCustomerApiFailed').hide();
      }
      else {
        $('#tblArticleList').show();
        $('#tblIngestionList').hide();
        $('#tblArticleAnnual').hide();
        $('#tblCustomerApiFailed').hide();
      }

      this.GetJournalArticleStage(filter);
    }
  }

  GetSummartItem(filtertype = "All", skipLoading = false): void {
    if (!skipLoading) {
      $("#LoadingImageDashSummary").show();
    }
    var postData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      FromDate: $('#Txt_FromDate').val(),
      ToDate: $('#Txt_ToDate').val()
    };
    ApiMethod.postMethod('dash/summary', postData).subscribe(
      resonse => {
        let _artSummary = resonse.articleSummary;
        this.modelData.ArticleSummary = JSON.parse(JSON.stringify(_artSummary));
        if (_artSummary.legnth != 0) {
          this.GetJournalArticleStage(_artSummary[0].Icon);
          this.ArticleListTitle = _artSummary[0].SummaryName;
        }
        $('#IssueDetails').find('h5').addClass('h5active');
        $("#LoadingImageDashSummary").hide();

        let summarTr = $('#span' + filtertype).closest('tr');
        $(summarTr).find('h5').addClass('h5active');



      },
      error => {
        $("#LoadingImageDashSummary").hide();
      }
    );

  }


  showArticleInfo(artId) {
    ArticleinfoComponent.ArticleInfo(artId);
    $('#divArticleInfo').show();
  }

  hide() {
    $('#divArticleInfo').hide();

  }

  ngAfterViewChecked(): void {
    $('.btnOverDue').html($('.overDue').length + " Over Due");
    $('.btnTodayDue').html($('.todayDue').length + " Today Due");
    $('.spAddIcon').hide();
  }

  GetArticleList(itemList) {
    $('table#tblArticleList tbody tr').hide();
    $('table#tblArticleList tbody tr.' + itemList).show();
  }


  showInfoPopUp(): void {
    if (localStorage.mdName == "JournalwiseIssueHome") {
      this.router.navigate(
        ['/issues'],
        { queryParams: { isId: localStorage.aEID } }
      );
    }
    else if (localStorage.mdName == "ArticleDetailsStatusHome") {
      //this.showArticleInfo(localStorage.aEID);
      $('#btnPopupartMeta').trigger('click');
    }
    else if (localStorage.mdName == "IngestionModule") {
      this.showIngestionLog(localStorage.aEID);
    }
    else if (localStorage.mdName == "CustomerApiFailed") {
      this.showAuthorData(localStorage.aEID);
    }
    else if (localStorage.mdName == "JournalBudgetHome") {
      this.ShowJournalBudgetArt();
    }

  }

  pageredirect(page, param) {
    this.router.navigate(['/' + page], {
      queryParams: { type: param }
    });
  }

  getFiltered() {
    console.log('filter');
  }

  resetFilter() {
    console.log('reset');
  }


  GetJournalBudgetList(): void {

    if ($('#Txt_JBFromDate').val() == '' && $('#Txt_JBToDate').val() == '') {
      ngswal("warning !", "Please Select Date", "warning");
    }
    else {
      $("#LoadingImage").show();
      var postData = {
        LoginID: localStorage.aLoginID,
        PublisherID: localStorage.aPubID,
        FromDate: $('#Txt_JBFromDate').val(),
        ToDate: $('#Txt_JBToDate').val(),
        ProjectManager: $('#ddl_ProjectManager').val().toString()
      };
      ApiMethod.postMethod('api/updatejrlbudget', postData).subscribe(
        resonse => {
          this.GetJournalArticleStage('JournalBudget');
          $("#LoadingImage").hide();
        },
        error => {
          $("#LoadingImage").hide();
        }
      );
    }

  }


  ShowJournalBudgetArt() {
    $("#LoadingImage").show();
    var postData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      FilterType: localStorage.dtColName,
      aEID: localStorage.aEID,
    };
    if (localStorage.dtColName == 'WIPArtPages') {
      this.Artpopuptitle = "WIP Article";
    } else if (localStorage.dtColName == 'PublishedArticle') {
      this.Artpopuptitle = "Published Article";
    }

    ApiMethod.postMethod('dash/WipandPublishedArticlelist', postData).subscribe(
      resonse => {

        if (resonse.aitemList.length != 0) {
          this.showpopupModal = true;

          this.dataSetBudgetArticle = JSON.stringify(resonse.aitemList); // Data List
          this.dataSetBudgetArticle = JSON.parse(this.dataSetBudgetArticle);
          this.tableDataBudgetArticle = $(this.tableBudgetArticle.nativeElement);

          //Dynamic datable
          let acolList = resonse.aitemColList;
          let dataItem = new DataParam();
          dataItem.acolList = acolList;
          dataItem.aNewButtonName = 'btn_AddNew';
          dataItem.dataTable = this.tableDataBudgetArticle;
          dataItem.dataset = this.dataSetBudgetArticle;
          dataItem.dtheight = (GlobalConstants.size.height - 220);
          dataItem.modulename = 'JournalBudgetArticleListModule';
          dataItem.defaultPagesize = -1;
          this.tableDataBudgetArticle = customfunctions.dynamicDataTable(dataItem);
          //Dynamic datable
        }
        else {
          ngswal("Failed !", "Article details not Found", "warning");
        }

        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
      }
    );
  }

  Artpopuphide() {
    this.showpopupModal = false;
  }


  //Customer Author details Update Popup
  form!: FormGroup;

  countries: string[] = [];
  states: string[] = [];


  getPubCountryState() {

    ApiMethod.getMethod(`dash/pubcountrystate/${localStorage.aPubID}`).subscribe(
      result => {

        this.countries = result.countryList.map(
          (country: any) => country.CountryName
        );
        this.states = result.stateList.map(
          (state: any) => state.StateName
        );


      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }


  authorDatapopupTitle: string = '';
  apiMessage: string = '';
  showAuthorData(id) {

    ApiMethod.getMethod(`dash/authorlist/${id}`).subscribe(
      result => {

        this.form = this.fb.group({
          contributors: this.fb.array([])
        });

        this.loadContributors(result.aitemList);
        if (result.aitemList.length > 0) {
          this.authorDatapopupTitle = `Author Details - ${result.aitemList[0].ArticleNo}`;
          this.apiMessage = result.aitemList[0].Message;
        }
        this.modelData.showAuthorDataModal = true;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }


  hideAuthorData() {
    this.modelData.showAuthorDataModal = false;
  }

  loadContributors(e: any): void {

    let contributors: any[] = [];

    if (Array.isArray(e)) {
      contributors = e;                          // ✔ already array
    }
    else if (Array.isArray(e?.data)) {
      contributors = e.data;                     // ✔ wrapped array
    }
    else if (e && typeof e === 'object') {
      contributors = [e];                        // ✔ single object → array
    }

    contributors.forEach(d => this.addContributor(d));
  }

  get contributors(): FormArray {
    return this.form.get('contributors') as FormArray;
  }

  createContributor(data?: any): FormGroup {
    return this.fb.group({
      sequenceNo: [this.contributors.length + 1],
      id: [data?.ID || 0, Validators.required],
      givenNames: [data?.Given_names || '', Validators.required],
      surname: [data?.Surname || '', Validators.required],
      primaryEmail: [data?.PrimaryEmail || '', [Validators.email]],
      isCorresponding: [data?.Corresp || false],
      ringgoldId: [data?.RinggoldId || ''],
      ringgoldInstitution: [data?.RinggoldInstitution || ''],
      address1: [data?.Address1 || ''],
      city: [data?.City || ''],
      state: [data?.State || 'Select'],
      country: [data?.Country || 'Select'],
      pincode: [data?.PostalCode || '']
    });
  }

  addContributor(data?: any): void {
    this.contributors.push(this.createContributor(data));
    this.resetSequence();
  }

  removeContributor(index: number): void {
    this.contributors.removeAt(index);
    this.resetSequence();
  }

  resetSequence(): void {
    this.contributors.controls.forEach((c, i) =>
      c.get('sequenceNo')?.setValue(i + 1)
    );
  }

  /** Allow only ONE corresponding author */
  onCorrespondingChange(index: number): void {
    this.contributors.controls.forEach((c, i) => {
      if (i !== index) {
        c.get('isCorresponding')?.setValue(false, { emitEvent: false });
      }
    });
  }

  submit(): void {
   
    $("#LoadingImage").show();
    var postData = {
      Id:localStorage.aEID,
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      AuthorList: this.form.value.contributors
    };
    ApiMethod.postMethod('dash/UpdateAuthorData', postData).subscribe(
      resonse => {
        console.log(resonse);
        if (resonse.status) {
          this.FetchListDataTab();
          ngswal("Updated !", resonse.message, "info");            
        }
        else {
          ngswal("Failed !", resonse.message, "warning");
        }

        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
      }
    );
  }

}
